import React from 'react';

const Reg = () => {
  return (
    <div className="agencyregister bg-gray-200 min-h-screen flex flex-col justify-center items-center md:flex-row">
      {/* Left Section (Image) */}
      <div className="bg-parent relative w-full h-80 md:h-auto md:w-1/2">
        <img
          className="mainimaage-icon w-full h-full object-cover"
          alt=""
          src="MainImaage.png"
        />
        <div className="bg-child absolute top-0 left-0 bg-black opacity-60 w-full h-full"></div>
      </div>

      {/* Right Section (Registration Form) */}
      <div className="registration bg-white rounded-lg shadow-md p-6 w-full md:w-96 mx-4 mt-4 md:mt-0">
        {/* Your form content here */}
      </div>

      {/* Logo and Title */}
      <div className="rescuelocator text-white absolute top-5 left-16 text-3xl font-semibold">
        RescueLocator
      </div>
      <img className="logo-icon absolute top-4 left-4" alt="" src="Logo.png" />
    </div>
  );
};

export default Reg;
